export const sortByPosition = (a: any, b: any) => {
  const positionA = a.position ?? a.auditOperationPosition;
  const positionB = b.position ?? b.auditOperationPosition;
  if (positionA === undefined || positionA === null) {
    if (positionB === undefined || positionB === null) return 0;
    return 1;
  }
  if (positionB === undefined || positionB === null) return -1;
  return positionA - positionB;
};